import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {getGroups} from '../actions/groups';


@connect(
  state => ({
    groups: state.groups.data
  }),
  dispatch => ({
    getGroups() {
      dispatch(getGroups());
    }
  })
)
export default class GroupInput extends PureComponent {
  componentDidMount() {
    this.props.getGroups();
  }

  render() {
    let {groups, value, label} = this.props;

    return (
      <select className="group-input" onChange={this._onChange} value={JSON.stringify(value)}>
        <option value="null">{label}</option>
        {groups.map(i =>
          <option value={JSON.stringify(i.Group_ID)} key={i.Group_ID}>{i.Group_Name}</option>
        )}
      </select>
    );
  }

  _onChange = (event) => {
    this.props.onChange(JSON.parse(event.target.value));
  }
}


// WEBPACK FOOTER //
// ./src/components/GroupInput.js